import {useParams} from "react-router-dom";
import {PlusIcon} from "..";
import {AppearComponentHandle} from "../../../components/AppearComponentHandle";
import AGButton from "../../../components/Button";
import {RolesHandle} from "../../../components/RolesHandle";
import {ContactProps} from "./contact.props";
import {Div} from "./contactModal.styled";
import AGButtonV2 from "../../../components/ButtonV2";
import {InquiriesIcon} from "../../../components/Header";
import {useState, useEffect} from 'react';
import {API_CONSTANT} from "../../../utils/constant";

const userProfileUrl = process.env.REACT_APP_AG_CONNECT_USER_PROFILE_URL;
const apiDomain = process.env.REACT_APP_API_DOMAIN;

const FirmSecondmentContactModal = ({
  setShow,
  bodyContent,
  data,
  setShowSendMessage,
}: ContactProps) => {
  const {id} = useParams();

  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  useEffect(() => {
      const handleResize = () => {
          setScreenWidth(window.innerWidth);
      };
  
      window.addEventListener("resize", handleResize);
  
      return () => {
          window.removeEventListener("resize", handleResize);
      };
  }, []);

  if (!data) {
    return null;
  }
  

  return (
    <>
      {data.firmSecondmentContacts && data.firmSecondmentContacts?.length ? (
        <Div className="contact-contents">
          {[...data.firmSecondmentContacts!]
            .sort((a, b) => {
              const aContact = data.individualFirmContacts!.find(
                (i) => i.individualId === a.fkIndividualId,
              );
              const bContact = data.individualFirmContacts!.find(
                (i) => i.individualId === b.fkIndividualId,
              );

              const aFullName = (aContact?.firstName ?? "") + " " + (aContact?.lastName ?? "");
              const bFullName = (bContact?.firstName ?? "") + " " + (bContact?.lastName ?? "");

              return aFullName.localeCompare(bFullName);
            })
            .map((x) => (
              <div
                className="firm-idv-contact"
                key={x.id}
              >
                <a
                  href={`${userProfileUrl}/${x.agConnectId}`}
                  rel="noopener"
                  className="contact-img"
                >
                  {x.avatar && typeof x.avatar === 'string' && x.avatar.trim() !== '' ? (
                    <img
                      src={x.avatar}
                      alt=""
                      className="ava"
                    />
                  ) : data?.logoPart ? (
                    <img
                      src={data.defaultLogo ? data.logoPart : `${apiDomain}${API_CONSTANT.DEFAULT_PROFILE.IMG}${encodeURIComponent(data.logoPart)}`}
                      alt=""
                      className="ava"
                    />
                  ) : (
                    <div className="ava" />
                  )}
                </a>
                <a
                  href={`${userProfileUrl}/${x.agConnectId}`}
                  rel="noopener"
                  className="contact-name"
                >
                  <p>
                    {data
                      .individualFirmContacts!.filter((i) => i.individualId === x.fkIndividualId)
                      .map(
                        (filteredContact) =>
                          filteredContact.firstName + " " + filteredContact.lastName,
                      )}
                  </p>
                </a>
              </div>
            ))}
        </Div>
      ) : (
        <Div className="btn-add-new">
          <RolesHandle
            firmId={data?.fkFirmId!}
            roles={["Admin", "FirmCommerceManagement"]}
          >
            <AGButton
              type={"Link"}
              icon={<PlusIcon />}
              onClick={() => {
                setShow();
              }}
            >
              {bodyContent}
            </AGButton>
          </RolesHandle>
        </Div>
      )}
    </>
  );
};

export default FirmSecondmentContactModal;
